import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <span className="text-9xl font-bold text-gradient">404</span>
        </div>

        <h1 className="text-3xl font-bold text-dark-800 mb-4">
          {t('notFound.title')}
        </h1>

        <p className="text-gray-500 mb-8 max-w-md mx-auto">
          {t('notFound.message')}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/">
            <Button variant="primary" size="lg">
              <Home className="w-5 h-5 mr-2" />
              {t('notFound.backToHome')}
            </Button>
          </Link>

          <Button
            variant="ghost"
            size="lg"
            onClick={() => window.history.back()}
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            {t('notFound.goBack')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
